/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CloseAction from './CloseAction/index'
import ExampleImage from './ExampleImage/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientImageExample/Content/Content"
  
}) {
let imageExampleLabelValueData = fromData.useDataValue({ viewPath,
context: 'image_example',
path: 'label',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width="90%"
 height="90%"
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 data="image_example.label"
 text={imageExampleLabelValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Example"
/>
</div>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<ExampleImage
{...childProps}
  viewPath={`${viewPath}/ExampleImage`}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}